export default __webpack_public_path__ + "5eec90be09103fd4c5f36e84cd099462.png";